import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const WhatsIncluded = () => {
  const inclusions = [
    "90 minutes of sports",
    "45–60 minutes party/social area",
    "Reserved sports area",
    "Tables & chairs",
    "Basic setup & cleanup",
    "Strikes & Shots facility experience",
  ];

  return (
    <div className="w-full py-16 bg-white px-4 md:px-8 lg:px-16">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-primaryBtnColor uppercase mb-8">
          Every Package. <br className="md:hidden" />
          <span className="text-primaryBtnHoverColor">The Full Strikes & Shots Experience.</span>
        </h2>
        
        <p className="text-lg font-poppins text-gray-600 mb-10">
          This reinforces that all packages receive the same experience standard. We don't compromise on quality based on your group size.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-left">
          {inclusions.map((item, index) => (
            <div key={index} className="flex items-start gap-3 p-4 bg-gray-50 rounded border border-gray-100">
              <FaCheckCircle className="text-green-500 mt-1 flex-shrink-0 text-xl" />
              <span className="font-poppins text-gray-800 font-medium">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatsIncluded;
